<template>
	<div class="resume-form" :job="job" :index="index">
		<el-form label-position="left" label-width="160px" :model="ruleForm" :rules="rules" ref="resume-form">
			<el-form-item label="職業" prop="job">
				<el-select v-model="ruleForm.job" placeholder="職業">
					<el-option label="教育工作者" value="教育工作者"></el-option>
					<el-option :label="occupation" :value="occupation" v-for="(occupation, index) in occupations" :key="index"></el-option>
				</el-select>
			</el-form-item>

			<el-form-item v-if="showTeacherOptions">
				<el-radio v-model="ruleForm.teacherGrade" label="elementary" @change="getTeacherSchool">國小</el-radio>
				<el-radio v-model="ruleForm.teacherGrade" label="junior" @change="getTeacherSchool">國中</el-radio>
				<el-radio v-model="ruleForm.teacherGrade" label="senior" @change="getTeacherSchool">高中</el-radio>
				<el-radio v-model="ruleForm.teacherGrade" label="others">其他</el-radio>
			</el-form-item>

			<el-row type="flex">
				<el-form-item label="單位地點" prop="city" style="margin-right:10px;">
					<el-col>
						<el-select v-model="ruleForm.city" placeholder="選擇縣市" @change="getTeacherSchool">
							<el-option :label="city" :value="city" v-for="(city, index) in cities" :key="index"></el-option>
						</el-select>
					</el-col>
				</el-form-item>
				<el-form-item prop="district" label-width="0">
					<el-col>
						<el-select v-model="ruleForm.district" placeholder="選擇區域" @change="getTeacherSchool">
							<el-option :label="district" :value="district" v-for="(district, index) in districts" :key="index"></el-option>
						</el-select>
					</el-col>
				</el-form-item>
			</el-row>

			<el-form-item label="單位名稱" prop="department">
				<el-select v-if="showTeacherOptions && ruleForm.teacherGrade!='others'" v-model="ruleForm.department" placeholder="單位名稱">
					<el-option :label="school.name" :value="school.name" v-for="(school, i) in schoolList" :key="i">{{school.name}}</el-option>
				</el-select>
				<el-input v-else class="department-input" v-model="ruleForm.department" placeholder="單位名稱"></el-input>
			</el-form-item>

			<el-form-item label="職位" prop="position">
				<el-input v-if="ruleForm.teacherGrade == 'others'" class="normal-input" v-model="ruleForm.position" placeholder="職位名稱"></el-input>
				<template v-else>
					<el-radio v-model="ruleForm.position" label="校長" /><br>
					<el-radio v-model="ruleForm.position" label="副校長" /><br>
					<el-radio v-model="ruleForm.position" label="校務及教務行政職（教務主任、教學組長、生教組長）" /><br>
					<el-radio v-model="ruleForm.position" label="總務及人事等相關行政職（出納會計、人事秘書等）" /><br>
					<el-radio v-model="ruleForm.position" label="班導師" /><br>
					<el-radio v-model="ruleForm.position" label="科任老師" /><br>
					<el-radio v-model="ruleForm.position" label="特教資優班老師" /><br>
					<el-radio v-model="ruleForm.position" label="特教資源班老師" /><br>
					<inputable-radio v-model="ruleForm.position" prefix="其他，" />
				</template>
			</el-form-item>

			<el-form-item label="科目名稱" v-if="showTeacherOptions" prop="teacherSubject">
				<el-input class="normal-input" v-model="ruleForm.teacherSubject" placeholder="科目名稱"></el-input>
			</el-form-item>

			<el-form-item>
				<el-checkbox v-model="ruleForm.presentlyEmployed" @change="handlePresentlyEmployed">我現在在這裡工作</el-checkbox>
			</el-form-item>

			<el-form-item prop="startTime">
				<el-row type="flex" :gutter="10">
					<el-col :span="10">
						<el-date-picker v-model="ruleForm.startTime" type="month" format="yyyy 年 MM 月" value-format="timestamp" placeholder="起始日期"></el-date-picker>
					</el-col>
					<el-col :span="3">{{ ruleForm.presentlyEmployed ? '至今' : '到' }}</el-col>
				</el-row>
			</el-form-item>

			<el-form-item v-if="!ruleForm.presentlyEmployed" prop="endTime">
				<el-row type="flex" :gutter="10">
					<el-col :span="10">
						<el-date-picker v-model="ruleForm.endTime" type="month" format="yyyy 年 MM 月" value-format="timestamp" placeholder="結束日期"></el-date-picker>
					</el-col>
					<el-col :span="3"></el-col>
				</el-row>
			</el-form-item>

			<el-form-item>
				<div class="layout-row button-box">
					<div @click="deleteJobVisibal = true">
						<slot name="button" />
					</div>
					<div class="button-tp color-white bg-text4 button cancel-button" @click="cancel()">取消</div>
					<div class="button-tp color-white bg-green1 button save-button" @click="save()">儲存</div>
				</div>
			</el-form-item>
		</el-form>
		<el-dialog title="確定刪除此工作經歷?" :visible.sync="deleteJobVisibal" width="30%">
			<span slot="footer" class="dialog-footer">
				<el-button @click="deleteJobVisibal = false">取 消</el-button>
				<el-button type="primary" @click="deleteJob(job.id)">确 定</el-button>
			</span>
		</el-dialog>

	</div>

</template>

<script>
import { mapActions } from "vuex";
var cityJson = require("@/data/city.json");
var occupationJson = require("@/data/occupation.json");

export default {
	props: ["job", "index"],
	data() {
		var validateTeacherGrade = (rule, value, callback) => {
			if (this.showTeacherOptions) {
				if (!value) {
					callback(new Error("請選擇任職單位類別"));
				}
			} else {
				callback();
			}
			callback();
		};
		var validateTeacherSubject = (rule, value, callback) => {
			if (this.showTeacherOptions) {
				if (!value) {
					callback(new Error("請填寫科目名稱"));
				}
			} else {
				callback();
			}
			callback();
		};
		var validateEndTime = (rule, value, callback) => {
			if (!this.ruleForm.presentlyEmployed) {
				if (!value) {
					callback(new Error("請選擇經歷結束時間"));
				}
			} else {
				callback();
			}
			callback();
		};
		return {
			cities: Object.keys(cityJson),
			occupations: occupationJson,
			deleteJobVisibal: false,
			schoolList: [],
			ruleForm: {
				job: "",
				teacherGrade: "",
				city: "",
				district: "",
				department: "",
				position: "",
				teacherSubject: "",
				presentlyEmployed: false,
				startTime: "",
				endTime: ""
			},
			rules: {
				job: [{ required: true, message: "請選擇職業", trigger: "blur" }],
				city: [
					{ required: true, message: "請選擇職業所在縣市", trigger: "blur" }
				],
				district: [
					{ required: true, message: "請選擇職業所在區域", trigger: "blur" }
				],
				department: [
					{ required: true, message: "請填寫職業單位", trigger: "blur" }
				],
				position: [
					{ required: true, message: "請填寫職位名稱", trigger: "blur" }
				],
				startTime: [
					{ required: true, message: "請選擇經歷時間", trigger: "blur" }
				],
				teacherGrade: [{ validator: validateTeacherGrade, trigger: "change" }],
				teacherSubject: [
					{ validator: validateTeacherSubject, trigger: "blur" }
				],
				endTime: [{ validator: validateEndTime, trigger: "blur" }]
			}
		};
	},
	computed: {
		showTeacherOptions() {
			return this.ruleForm.job == "教育工作者";
		},
		districts() {
			return cityJson[this.ruleForm.city] || [];
		}
	},
	methods: {
		...mapActions("user", ["updatePersonJob", "deletePersonJob", "getSchool", "newPersonJob"]),
		handlePresentlyEmployed(checked) {
			this.ruleForm.endTime = checked ? Date.now() : null;
		},
		async getTeacherSchool() {
			if (
				this.ruleForm.teacherGrade &&
				this.ruleForm.city &&
				this.ruleForm.district
			) {
				let data = {
					category: this.transTeacherGrade(this.ruleForm.teacherGrade),
					city: this.ruleForm.city,
					district: this.ruleForm.district
				};
				this.schoolList = await this.getSchool(data);
			}
		},
		transTeacherGrade(teacherGrade) {
			switch (teacherGrade) {
				case "elementary":
					return "1";
					break;
				case "junior":
					return "2";
					break;
				case "senior":
					return 3;
					break;
			}
		},
		save() {
			this.$refs["resume-form"].validate(async valid => {
				if (valid) {
					let data = {
						id: this.job.id ? this.job.id : undefined,
						type: this.ruleForm.job,
						city: this.ruleForm.city,
						teacher_grade: this.ruleForm.teacherGrade,
						district: this.ruleForm.district,
						department: this.ruleForm.department,
						position: this.ruleForm.position,
						subject: this.ruleForm.teacherSubject,
						presently_employed: this.ruleForm.presentlyEmployed,
						start_time: this.ruleForm.startTime,
						end_time: this.ruleForm.endTime
					};
					console.log("data", data);
					try {
						if (data.id) {
							await this.updatePersonJob(data);
						} else {
							await this.newPersonJob(data);
						}
						this.$message.success("修改成功");
						this.$emit("cancel", this.index);
					} catch (e) {
						this.$messagge.error(e);
						console.log("resume save error", e);
					}
				} else {
					console.log("error");
					return false;
				}
			});
		},
		cancel() {
			console.log("cancel index", this.index);
			this.$emit("cancel", this.index);
		},
		async deleteJob(id) {
			try {
				await this.deletePersonJob(id);
				this.deleteJobVisibal = false;
				this.$emit("deleteJob", this.index);
			} catch (e) {
				this.$messagge.error(e);
				console.log("error", e.message);
			}
		},
		initJob() {
			this.ruleForm.job = this.job.type;
			this.ruleForm.teacherGrade = this.job.teacher_grade;
			this.ruleForm.city = this.job.city;
			this.ruleForm.district = this.job.district;
			this.ruleForm.department = this.job.department;
			this.ruleForm.position = this.job.position;
			this.ruleForm.teacherSubject = this.job.subject;
			this.ruleForm.presentlyEmployed = this.job.presently_employed
				? this.job.presently_employed
				: false;
			this.ruleForm.startTime = this.job.start_time;
			this.ruleForm.endTime = this.job.end_time;
		}
	},
	created() {
		this.initJob();
	}
};
</script>

<style lang="scss" scoped>
.resume-form {
	.button-box {
		justify-content: flex-end;

		.button {
			width: 150px;
			height: 30px;
			margin-left: 10px;
		}
	}

	.normal-input {
		width: 196px;
	}

	.department-input {
		width: 402px;
	}
}
</style>
